import { apiInterfaceForJson } from '../common/apiManager';

export const generateUniqueKey = () => {
    return apiInterfaceForJson('/order/v1/uniquekey', 'POST');
};

export const generateBarcodeImage = (params) => {
    return apiInterfaceForJson('/order/v1/generateBarcodeImage', 'POST', params);
};

export const saveRequisitionChanges = (reqInfo) => {
    let updatedRequisition = {
        test_id: reqInfo.testId,
        provider: {
            first_name: reqInfo.providerFirstName,
            last_name: reqInfo.providerLastName,
            npi: reqInfo.providerNPI
        },
        test_info: {
            code: reqInfo.testInfoCode,
            description: reqInfo.testInfoDescription,
            specimenType: reqInfo.specimenType,
            sample: reqInfo.sample,
            collected: reqInfo.collectedDate,
            collector_name: reqInfo.collectorName,
            received: reqInfo.receivedDate,
            requisition: reqInfo.requisition
        },
        patient_id: reqInfo.patientId,
        facility_id: reqInfo.facilityId,
        order_date: reqInfo.orderDate,
        facility_order_id: reqInfo.facilityOrderId,
        facility_source: reqInfo.facilitySource,
        diagnosis_code: reqInfo.diagnosisCode,
        is_HL7_requisition: false
    };

    if (reqInfo.patientInsuranceId) {
        updatedRequisition.patient_insurance_id = reqInfo.patientInsuranceId;
    }
    if (reqInfo.importNova) {
        updatedRequisition.importNova = reqInfo.importNova;
    }
    if (reqInfo.symptoms && reqInfo.symptoms.length) {
        updatedRequisition.symptoms = reqInfo.symptoms;
    }
    if (reqInfo.orderType) {
        updatedRequisition.order_type = reqInfo.orderType;
    }
    if (reqInfo.orderIds) {
        updatedRequisition.orderIds = reqInfo.orderIds;
    }
    if (reqInfo._id) {
        updatedRequisition._id = reqInfo._id;
    }
    if (reqInfo.parent_id) {
        updatedRequisition.parent_id = reqInfo.parent_id;
    }
    if (reqInfo.medicationIds && reqInfo.medicationIds.length) {
        updatedRequisition.medicationIds = reqInfo.medicationIds;
    }
    if (reqInfo.externalOrderId) {
        updatedRequisition.external_sample_id = reqInfo.externalOrderId;
    }
    return apiInterfaceForJson('/order/v1/requisition', 'POST', updatedRequisition);
};

export const createRequisitionPDF = (params) => {
    let updatedOrder = {
        orderId: params.orderId
    };
    return apiInterfaceForJson('/order/v1/createRequisitionPDF', 'POST', updatedOrder);
};

export const notifyGrubbsUploaded = () => {
    return apiInterfaceForJson('/order/v1/notifyGrubbsUploaded', 'POST');
};

export const notifyBrowserGrubbsUploaded = () => {
    const body = {
        title: 'Grubbs uploaded',
        text: 'Grubbs has now uploaded their spreadsheet for the day.',
        target: 'superadmin'
    };
    return apiInterfaceForJson('/notifications/v1/browser', 'POST', body);
};

export const sendReportNewSample = (params) => {
    return apiInterfaceForJson('/order/v1/sendReportNewSample', 'POST', params);
};

export const revertCancelRequisition = (params) => {
    return apiInterfaceForJson('/order/v1/revertCancelRequisition', 'POST', params);
};

export const getOrderOverview = () => {
    return apiInterfaceForJson('/order/v1/getOverview', 'POST');
};

export const fetchDiagnosisCodesList = () => {
    return apiInterfaceForJson('/order/v1/diagnosis_codes/list', 'GET');
};
